import HeroSection from './components/HeroSection';
import BlogList from './components/BlogList';
import { useSEO } from '../../utils/seo';

const BlogPage = () => {
  const siteUrl = typeof VITE_SITE_URL !== 'undefined' ? VITE_SITE_URL : 'https://example.com';

  useSEO({
    title: 'ブログ&新着情報｜おかやま鍼灸院 - 岡山市の鍼灸情報',
    description: 'おかやま鍼灸院のブログと新着情報。岡山市の鍼灸治療に関する最新情報、健康に役立つ情報、院内のお知らせなどを発信しています。肩こり・腰痛・美容鍼など、様々な健康情報をお届けします。',
    keywords: '岡山 鍼灸 ブログ, 岡山市 鍼灸院 新着情報, 健康情報 岡山, 鍼灸治療 情報, おかやま鍼灸院 お知らせ',
    canonical: `${siteUrl}/blog`,
    ogType: 'website',
    schema: {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "おかやま鍼灸院ブログ",
      "description": "岡山市の鍼灸治療に関する最新情報、健康に役立つ情報を発信",
      "url": `${siteUrl}/blog`,
      "publisher": {
        "@type": "Organization",
        "name": "おかやま鍼灸院",
        "logo": {
          "@type": "ImageObject",
          "url": "https://public.readdy.ai/ai/img_res/57c68b45-512f-49fb-a7a0-ac00437662e3.png"
        }
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <main>
        <HeroSection />
        <BlogList />
      </main>
    </div>
  );
};

export default BlogPage;
